import axios from "axios"
import { URL } from "./settings"

export default class StudentsService {
    static async getStudents(filters) {
        try {
            const response = await axios.post(`${URL}/my-students/my_students/`,
                filters,
                { withCredentials: true },
            )
            console.log('StudentsService::getStudents response:', response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }

    static async getStudentsProlongations(filters) {
        try {
            const response = await axios.post(`${URL}/my-students/renewals/`,
                {},
                {
                    params: {
                        filter_start_date: filters.filter_start_date,
                        filter_end_date: filters.filter_end_date,
                    },
                    withCredentials: true,
                }
            )
            console.log('StudentsService::getStudentsProlongations response:', response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }

    static async patchStudent(studentSiteId, data) {
        try {
            const response = await axios.patch(`${URL}/student/${studentSiteId}/`,
                data,
                { withCredentials: true },
            )
            console.log('StudentsService::patchStudent response:', response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }

    static async updateCommunicationType(studentSiteId, typeId) {
        try {
            const response = await axios.patch(`${URL}/student/${studentSiteId}/communication_type`,
                { new_communication_type_id: typeId },
                { withCredentials: true },
            )
            console.log('StudentsService::updateCommunicationType response:', response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }

    static async updateOnboardingStatus(studentSiteId, newStatusId) {
        try {
            const response = await axios.patch(`${URL}/student/${studentSiteId}/student_onboarding_status`,
                { new_student_onboarding_status_id: newStatusId },
                { withCredentials: true },
            )
            console.log('StudentsService::updateOnboardingStatus response:', response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }

    static async getPurchaseTags() {
        try {
            const response = await axios.get(`${URL}/admin/my_students/tag/`,
                { withCredentials: true }
            )
            console.log("StudentsService::getPurchaseTags response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }

    static async addPurchaseTag(tagId, purchaseId) {
        try {
            const response = await axios.post(`${URL}/my-students/my_students/add_tag_to_purchase`,
                { tag_id: tagId, purchase_id: purchaseId },
                { withCredentials: true }
            )
            console.log("StudentsService::addPurchaseTag response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }

    static async deletePurchaseTag(tagId, purchaseId) {
        try {
            const response = await axios.delete(`${URL}/my-students/my_students/remove_tag_from_purchase`,
                {
                    data: { tag_id: tagId, purchase_id: purchaseId },
                    withCredentials: true,
                }
            )
            console.log("StudentsService::addPurchaseTag response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }

    static async getCommunicationTypes() {
        try {
            const response = await axios.get(`${URL}/student/communication_type`, {
                withCredentials: true
            })
            console.log("StudentsService::getCommunicationTypes response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }

    static async getOnboardingStatuses() {
        try {
            const response = await axios.get(`${URL}/student/student_onboarding_status`, {
                withCredentials: true
            })
            console.log("StudentsService::getOnboardingStatuses response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }

    static async getProlongationFiles() {
        try {
            const response = await axios.get(`${URL}/my-students/file/`,
                { withCredentials: true }
            )
            console.log("StudentsService::getProlongationFiles response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }

    static async addProlongationFile(formData) {
        try {
            const response = await axios.post(`${URL}/my-students/file/`,
                formData,
                { withCredentials: true }
            )
            console.log("StudentsService::addProlongationFile response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }

    static async editProlongationFile(formData) {
        try {
            const response = await axios.patch(`${URL}/my-students/file/`,
                formData,
                { withCredentials: true }
            )
            console.log("StudentsService::editProlongationFile response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }

    static async deleteProlongationFile(fileId) {
        try {
            const response = await axios.delete(`${URL}/my-students/file/${fileId}`,
                { withCredentials: true }
            )
            console.log("StudentsService::deleteProlongationFile response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }
}
